package com.neurobs.ccabserver.translation.components.translationreplacement

import com.neurobs.ccabserver.translation.components.translationreplacement.components.{MatchingTranslationsView, SubPhraseSearch, TranslationReplacementControl, TranslationSave, TranslationView}
import com.neurobs.ccabserver.translation.states.{TranslationSubSearchStateGenerator, TranslatorStateGenerator}
import com.neurobs.react.semanticui.{UiContainerFactory, UiGridFactory, UiMessageFactory}
import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.core.facade.ReactElement

@react
object TranslationReplacement {
  case class Props(enclosingElement: (ReactElement*) => ReactElement)
  val component = FunctionalComponent[Props] { props =>
    val translatorState = TranslatorStateGenerator.accessState
    val translationSubSearchState = TranslationSubSearchStateGenerator.accessState


    def TranslationViewElement() = {
      translationSubSearchState.matchingTranslationsState.ConditionalElements(
        LoadingElement = () => null,
        ErrorElement = UiMessageFactory.BasicErrorMessage(_),
        DataElement = MatchingTranslationsView(_)
      )
    }

    translatorState.selectedTranslator match {
      case None => null
      case Some(translator) =>
        props.enclosingElement(
            Seq[ReactElement](
              UiGridFactory.Grid(
                SubPhraseSearch(translator.id, UiGridFactory.GridColumn(_)("five wide")),
                TranslationReplacementControl(UiGridFactory.GridColumn(_)("eleven wide"))
              ),
              TranslationViewElement()
            )
        )
    }
  }
}
